import { useCallback, useState } from "react"

import type { Return } from "./types"

export const useToggle = (initial?: boolean): Return => {
	const [isOpen, setIsOpen] = useState(initial ?? false)

	const open = useCallback(() => setIsOpen(true), [])
	const close = useCallback(() => setIsOpen(false), [])

	return [isOpen, open, close]
}
